import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Alert, util } from '@thecb/components';
import { genRandomString } from '../../utils/helpers';
export const AlertBarContainer = styled.div`
  position: ${({ position }) => position};
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 99;
`;

export const AlertBarWrapper = styled.div`
  max-width: 85.714rem; // 1200px
  width: 100%;
  margin: 0 auto;
`;

export const AlertBar = ({
  alerts = [],
  deleteAlert = util.general.noop,
  clearAlerts = util.general.noop,
  isToast = false,
  alertClearTimeout = 10000,
}) => {
  useEffect(() => () => clearAlerts(), []);
  useEffect(() => {
    if (isToast) {
      let timeout = setTimeout(() => {
        clearAlerts();
      }, alertClearTimeout);
      return () => clearTimeout(timeout);
    }
  }, []);

  return (
    <AlertBarWrapper>
      <AlertBarContainer position={isToast ? 'absolute' : 'static'}>
        {alerts.map((alert, i) => (
          <Alert
            themeValues={{ background: alert.background, border: alert.border }}
            key={genRandomString(alert.heading)}
            alertPosition={i}
            {...alert}
            onLinkClick={() => deleteAlert(i)}
            extraStyles="min-height: auto"
          />
        ))}
      </AlertBarContainer>
    </AlertBarWrapper>
  );
};

export default AlertBar;
